import { Model } from '@nozbe/watermelondb'
import { field, text, date, lazy, writer } from '@nozbe/watermelondb/decorators'
import { Q } from '@nozbe/watermelondb';

export const UserColumns = [
    { name: 'realm_id', type: 'number' },
    { name: 'name', type: 'string' },
    { name: 'email', type: 'string' },
    { name: 'created_at', type: 'number' },
    { name: 'updated_at', type: 'number' },
]

export class User extends Model {
    static table = 'user'
    
    @field('realm_id') realmId
    @field('name') name
    @field('email') email
    @date('created_at') createdAt
    @date('updated_at') updatedAt
}